/**
 * @generated SignedSource<<ba549e7bdb6d0f437350dc2b7fea560f>>
 * @relayHash 92b5f865f5d3e169ae4c9331a8c93231
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b9901a7bacba0bde9d9d42c3a13ce1a30e9b0aebeb702a0094b5f8ca8c6efa63

import type { ConcreteRequest, Query } from 'relay-runtime';
export type LoomUserStatus = "LINKED" | "LINKED_ENTERPRISE" | "MASTERED" | "NOT_FOUND" | "%future added value";
export type LoomAuthStateQuery$variables = Record<PropertyKey, never>;
export type LoomAuthStateQuery$data = {
  readonly loomUserStatus: LoomUserStatus | null | undefined;
};
export type LoomAuthStateQuery = {
  response: LoomAuthStateQuery$data;
  variables: LoomAuthStateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "loomUserStatus"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "LoomAuthStateQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "LoomAuthStateQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "92b5f865f5d3e169ae4c9331a8c93231",
    "id": "b9901a7bacba0bde9d9d42c3a13ce1a30e9b0aebeb702a0094b5f8ca8c6efa63",
    "metadata": {},
    "name": "LoomAuthStateQuery",
    "operationKind": "query",
    "text": "query LoomAuthStateQuery{loomUserStatus}"
  }
};
})();

(node as any).hash = "b0b71e4c1a4d03a9f0016476ce67cefb";

export default node;
